import { TextField } from '@mui/material'
import React from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { MoveOutFormFields } from '../MoveOutWizard'

interface NewAddressStepProps {
	form: UseFormReturn<MoveOutFormFields>
}

const NewAddressStep: React.FC<NewAddressStepProps> = ({ form }) => {
	const { t } = useTranslation('modals_moveOutContact')
	return (
		<div>
			<div className='text-xs text-text-dark dark:text-white'>
				{t('newAddressStep.description')}
			</div>
			<Controller
				control={form.control}
				name='newAddress'
				defaultValue=''
				rules={{
					required: true,
					maxLength: 18,
					minLength: 18,
				}}
				render={({ field }) => (
					<TextField
						fullWidth
						title={t('newAddressStep.newAddress')}
						label={t('newAddressStep.newAddress')}
						variant='outlined'
						margin='normal'
						{...field}
					/>
				)}
			/>

			<Controller
				control={form.control}
				name={'newZipcode'}
				defaultValue=''
				rules={{
					required: true,
					maxLength: 18,
					minLength: 18,
				}}
				render={({ field }) => (
					<TextField
						fullWidth
						type='number'
						title={t('newAddressStep.newZipCode')}
						label={t('newAddressStep.newZipCode')}
						variant='outlined'
						margin='normal'
						{...field}
					/>
				)}
			/>

			<Controller
				control={form.control}
				name={`newPostalArea`}
				defaultValue=''
				rules={{
					required: true,
					maxLength: 18,
					minLength: 18,
				}}
				render={({ field }) => (
					<TextField
						fullWidth
						title={t('newAddressStep.newPostalArea')}
						label={t('newAddressStep.newPostalArea')}
						variant='outlined'
						margin='normal'
						{...field}
					/>
				)}
			/>
		</div>
	)
}

export default NewAddressStep
